import styles from './NudgeTemplate.less';
// @flow

import React from 'react';

import {
  Paragraph,
  Text,
  Button,
  CrossIcon,
  Hidden
} from 'seek-style-guide/react';

type Props = {
  imageUrl?: string,
  isThankYouMessage: boolean,
  id?: string,
  firstName: string,
  prompt: any,
  text?: any,
  callToActions?: Array<Object>,
  onCtaClick?: Function,
  onDismiss: Function
};

const NudgeTemplate = ({
  imageUrl,
  isThankYouMessage,
  id,
  firstName,
  prompt,
  text,
  callToActions,
  onCtaClick,
  onDismiss
}: Props) => (
  <aside className={styles.root}>
    <div>
      <Paragraph>
        {firstName && (
          <Text heading>
            {`
            ${isThankYouMessage ? 'Thanks ' : ''}
            ${firstName}${isThankYouMessage ? '!' : ','}
            `}
          </Text>
        )}
        {prompt && <Text subheading>{prompt}</Text>}
        {text && <Text>{text}</Text>}
      </Paragraph>
      <div className={styles.ctas}>
        {callToActions &&
          callToActions.map(({ value, displayText }) => (
            <Button
              onClick={onCtaClick({ nudgeId: id, ctaValue: value })}
              className={styles.cta}
              key={value}
              color="blue"
            >
              {displayText}
            </Button>
          ))}
      </div>
    </div>
    {imageUrl && (
      <Hidden
        mobile
        className={styles.image}
        style={{ backgroundImage: `url("${imageUrl}")` }}
      />
    )}
    <CrossIcon
      onClick={onDismiss({ nudgeId: id, isThankYouMessage })}
      className={styles.dismissIcon}
      svgClassName={styles.dismissSvg}
    />
  </aside>
);

export default NudgeTemplate;
